<div *ngIf="!AccessAllowed && CompletedLoading">
  <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
    <h3 style="margin: 0;">Brevo Integration</h3>
    <button pButton type="button" label="Back to Integrations" icon="pi pi-arrow-left"
            class="p-button-outlined" (click)="goBack()">
    </button>
  </div>

  <div class="surface-card p-4 shadow-2 border-round">
    <div class="grid formgrid p-fluid">

      <!-- Brevo Enabled Toggle -->
      <div class="field mb-4 col-12">
        <label class="font-medium">Brevo Enabled</label>
        <div class="mt-2">
          <p-selectButton style="width:350px;display:block;" [(ngModel)]="brevoEnabled" [options]="brevoStateOptions"
             (onChange)="onBrevoEnabledChange()" optionLabel="label" optionValue="value">
          </p-selectButton>
        </div>
      </div>

      <!-- API Key Field (only shown when enabled) -->
      <div *ngIf="brevoEnabled" class="field mb-4 col-12">
        <label for="apiKey" class="font-medium">API Key</label>
        <input id="apiKey" [(ngModel)]="apiKey" pInputText
               placeholder="Enter your Brevo API key"
               style="width: 100%; display: block;">
      </div>

      <!-- Save Button -->
      <div *ngIf="brevoEnabled" class="field mb-4 col-12">
        <button style="width:350px;" pButton type="button"
                [loading]="settingsSaving"
                (click)="saveSettings()"
                class="p-button-success"
                [disabled]="settingsSaving || !apiKey">
          <i class="pi pi-save" style="margin-right: 8px;"></i>
          Save Settings
        </button>
      </div>

    </div>
  </div>
</div>

<p-toast></p-toast>
